
import {BIconEyeFill} from "bootstrap-vue";
import {compareNumber, toHtmlId} from "kistenkonfigurator/build/util/util";
import Vue, {PropType} from "vue";
import {parseProductDescription} from "kistenkonfigurator/build/util/parse-product-description";
import AddToCart from "../cart/AddToCart.vue";
import {ProductModelFactory} from "../../model/product/ProductModelFactory";
import {
  canBeConfigured,
  getExternalProductId,
  getProductOverviewImage,
  getProductUrl,
  toDefaultConfigurationObject,
} from "../../model/ProductBusinessLogic";
import ProductPriceTable from "../../components/product/ProductPriceTable.vue";
import {Product, ProductAttributeValue, ProductDTO} from "../../model/rest/data-contracts";
import ProductLink from "./ProductLink.vue";
import PriceDisplay from "./PriceDisplay.vue";

export default Vue.extend({
  name: "ProductInOverview",
  components: {
    ProductPriceTable,
    ProductLink,
    PriceDisplay,
    AddToCart,
    BIconEyeFill,
  },
  props: {
    /** @type {Product} */
    product: {
      type: Object as PropType<ProductDTO>,
      default: () => ProductModelFactory.createEmptyOverviewProduct(),
      required: true,
    },
  },
  provide() {
    return {
      generateProductImage: () => this.productImageUrl,
    };
  },
  computed: {
    values(): Array<ProductAttributeValue> {
      if (this.product.values == null) {
        return [];
      }
      return this.product.values
          // .filter((v: ProductAttributeValue) => isAttributeVisible(v.productAttribute.visibility, AttributeVisibility.PRODUCT_CONFIGURATOR)
          .filter(() => false)
          .sort((a: ProductAttributeValue, b: ProductAttributeValue) => compareNumber(a.productAttribute.order, b.productAttribute.order));
    },
    productImageAltText(): string {
      return this.product.name!;
    },
    isConfigurationProduct(): boolean {
      return canBeConfigured(this.product);
    },
    hasVolumeDiscount(): boolean {
      return !this.isConfigurationProduct && this.product.graduatedPrice != null ? this.product.graduatedPrice.length > 1 : false;
    },
    productImageUrl(): string {
      return getProductOverviewImage(this.$axios.defaults.baseURL!, this.product);
    },
    externalProductId(): string {
      const customerId = this.$auth.getCustomerId();
      const isAdmin = this.$auth.hasAdminPermission();
      return getExternalProductId(this.product, customerId, isAdmin).join(", ");
    },
  },
  methods: {
    getAnchorId(): string {
      return toHtmlId(this.product.name);
    },
    getProductUrl(): string {
      return getProductUrl(this as any, this.product, null);
    },
    getProductDescription(product: Product) {
      return parseProductDescription(toDefaultConfigurationObject(product), product.description);
    },
  },
});
